import React from 'react';
import * as S from './LoadingSpinner.styles';

export const LoadingSpinner = () => {
  return <S.Spinner data-testid='spinner' />;
};
